import { createSlice } from "@reduxjs/toolkit";

const updateCartItemQuantity = (items, sku, quantity) => items.map((ci) => ci.sku === sku ? { ...ci, quantity} : ci);
const emptyCartState = [];

export const cartSlice = createSlice({
    name: 'cart',
    initialState: emptyCartState,
    reducers: {
        addToCart: (state, action) => {
            const sku = action.payload.sku;
            var existingItem = state.filter((i) => i.sku === sku);
            var newState;

            if(existingItem.length) {
                const newQuantity = parseInt(action.payload.quantity) + existingItem[0].quantity;
                newState = updateCartItemQuantity(state, sku, newQuantity);
            }
            else {
                newState = [...state, action.payload];
            }
            return newState;
        },
        emptyCart: (state, action) => {
            return emptyCartState;
        },
        updateQuantity: (state, action) => {
            const { sku, quantity } = action.payload;

            var newState;

            if(quantity === 0) {
                newState = state.filter((cartItem) => cartItem.sku !== sku);
            } else {
                newState = updateCartItemQuantity(state, sku, quantity);
            }

            return newState;
        }
    }
});

export const {
    addToCart,
    emptyCart,
    updateQuantity,
} = cartSlice.actions;

export default cartSlice.reducer;